export const ALLOWED_SYMBOLS_BEFORE_ENTITY = ['', '\n', '*', '~', '_', ' '];
